// Landing.js
import { connect } from 'react-redux';
import getMeData from '../selector/getMeData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getModalData from '../selector/getModalData.js';
import getOperationData from '../selector/getOperationData.js';
import getIsRemoteConfigMerged from '../selector/getIsRemoteConfigMerged.js';
import addModal from '../action/addModal.js';
import mergeMeData from '../action/mergeMeData.js';
import removeModals from '../action/removeModals.js';
import Landing from '../component/Landing.jsx';
import {
  NEED_LANDING_COUNTRIES,
  LANDING_BLOCKER_URL,
  UNDER_AGE_EXIT_URL,
} from '../RemoteConfigKeys.js';
import { CONFIG_PRIORITY_PRESENCE_CLIENT } from '../resource/configPriority.js';

const mapStateToProps = state => {
  const token = getMeData(state, 'token');
  const status = getModalData(state, 'LandingPageModal', 'status');
  const isDisplaying = 'display' === status;
  const isPresenceClientRemoteConfigMerged = getIsRemoteConfigMerged(
    state,
    CONFIG_PRIORITY_PRESENCE_CLIENT
  );
  return {
    token,
    status,
    hasAgeVerified: getMeData(state, 'hasAgeVerified'),
    userCountry: getMeData(state, 'country'),
    needLandingCountries: getRemoteConfigData(state, NEED_LANDING_COUNTRIES),
    landingBlockerUrl: getRemoteConfigData(state, LANDING_BLOCKER_URL),
    underAgeExitUrl: getRemoteConfigData(state, UNDER_AGE_EXIT_URL),
    isDisplaying,
    canDisplayIntercom: getOperationData(
      state,
      ['intercom'],
      'canDisplayIntercom'
    ),
    lastAgeVerifiedTimestamp: getMeData(state, 'lastAgeVerifiedTimestamp'),
    isPresenceClientRemoteConfigMerged,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    open: () =>
      dispatch(
        addModal({
          id: 'LandingPageModal',
          isLowerThanAll: true,
        })
      ),
    close: () => {
      dispatch(mergeMeData({ field: 'hasAgeVerified', value: true }));
      dispatch(
        mergeMeData({ field: 'lastAgeVerifiedTimestamp', value: Date.now() })
      );
      return dispatch(
        removeModals({ ids: ['LandingPageModal'], transitionStatus: 'closing' })
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Landing);
